import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const MultiStepModalContext = createContext(void 0);
const MultiStepModalProvider = ({
  children,
  goToStep = () => {
  }
}) => /* @__PURE__ */ jsx(
  MultiStepModalContext.Provider,
  {
    value: {
      goToStep
    },
    children
  }
);
const useMultiStepModalContext = () => {
  const context = useContext(MultiStepModalContext);
  if (!context) {
    throw new Error("useMultiStepModalContext must be used within a MultiStepModalProvider");
  }
  return context;
};
export {
  MultiStepModalProvider,
  useMultiStepModalContext
};
